export default __webpack_public_path__ + "static/media/courierMarketplace.adaf91f9.jpeg";